import { Backend } from "./BundleBackend";
import i18n from "i18next";
import { getOptions } from "./getOptions";
export function createInstance(modules, lng) {
    return i18n.createInstance(getOptions(modules, lng)).use(Backend);
}
